/** Shared formatting for money, dates and grade bands. */

export const MONTH_NAMES = [
  'كانون الثاني', 'شباط', 'آذار', 'نيسان', 'أيار', 'حزيران',
  'تموز', 'آب', 'أيلول', 'تشرين الأول', 'تشرين الثاني', 'كانون الأول',
];

const DAY_NAMES = ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];

export const money = (cents) => `$${(cents || 0).toLocaleString('en-US')}`;

/** "2026-09" -> "أيلول 2026" */
export const monthLabel = (yyyyMm) => {
  if (!yyyyMm) return '—';
  const [y, m] = yyyyMm.split('-').map(Number);
  if (!m || m < 1 || m > 12) return '—';
  return `${MONTH_NAMES[m - 1]} ${y}`;
};

/** "2026-09-23" -> "الأربعاء، 23 أيلول 2026" */
export const dateLabel = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return `${DAY_NAMES[d.getDay()]}، ${d.getDate()} ${MONTH_NAMES[d.getMonth()]} ${d.getFullYear()}`;
};

/** "2026-09-23" -> "23 أيلول" — for dense lists where the year is implied. */
export const shortDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return `${d.getDate()} ${MONTH_NAMES[d.getMonth()]}`;
};

/** The YYYY-MM a date string belongs to, for month grouping/filters. */
export const monthKey = (iso) => (iso || '').slice(0, 7);

/**
 * Grade bands, matching the wording the school already used in V1:
 * 90+ ممتاز, 75+ جيد جداً, 60+ جيد, 50+ مقبول, below راسب.
 * Returns a token name rather than a hex so the CSS owns the palette.
 */
export function gradeBand(percentage) {
  const p = Number(percentage) || 0;
  if (p >= 90) return { label: 'ممتاز', tone: 'success' };
  if (p >= 75) return { label: 'جيد جداً', tone: 'info' };
  if (p >= 60) return { label: 'جيد', tone: 'primary' };
  if (p >= 50) return { label: 'مقبول', tone: 'warning' };
  return { label: 'راسب', tone: 'danger' };
}

export const ATTENDANCE_LABELS = {
  present: 'حاضر',
  absent: 'غائب',
  excused: 'غياب بعذر',
  late: 'متأخر',
};

export const attendanceTone = (status) => ({
  present: 'success',
  absent: 'danger',
  excused: 'warning',
  late: 'info',
}[status] || 'neutral');
